module.exports = __webpack_public_path__ + "static/img/IMG_20170905_183221.954bbf80.jpg";